export const REBOOT_DEVICE_OPEN_MODAL = "REBOOT_DEVICE_OPEN_MODAL";
export const REBOOT_DEVICE_CLOSE_MODAL = "REBOOT_DEVICE_CLOSE_MODAL";

export const REBOOT_DEVICE_REQUEST = "REBOOT_DEVICE_REQUEST";
export const REBOOT_DEVICE_RESULT = "REBOOT_DEVICE_RESULT";

export const REBOOT_DEVICE_GET_DEVICE_REQUEST = "REBOOT_DEVICE_GET_DEVICE_REQUEST";
export const REBOOT_DEVICE_GET_DEVICE_RESULT = "REBOOT_DEVICE_GET_DEVICE_RESULT";